import beneficiaryChange from './beneficiaryPage.vue';
import applicantChange from './applicantChangeConfirmData.vue';
// import policylianChange from './policylianPage.vue';

export default {
    beneficiaryChange,
    applicantChange,
    // policylianChange,
};
